import * as React from "react";
import { WidgetFrame, Locale }
  from "../../personal-studio-components/studio";
//import * as cls from "./Sample.module.scss";
export { Sample, SampleModel, SampleView };
/**
 * Компонент.
 * @param {SampleModel} props - Атрибуты элемента.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Sample() {
  const [model, updateModel] = React.useState(new SampleModel({}));
  model.onToggle = onToggle;
  return <SampleView model={model} />;
  function onToggle(event) {
    event.preventDefault();
    model.state = !model.state;
    updateModel(new SampleModel(model));
  }
}
/**
 * Модель компонента.
 */
class SampleModel {
  /**
   * Состояние.
   * @type {boolean}
   * @default false
   */
  state = false;
  /**
   * Обработчик события.
   * @type {function}
   * @default event => {event.preventDefault();}
   */
  onToggle = event => { event.preventDefault(); };
  /**
   * Копирует свойства объекта.
   * @param {SampleModel} props - Свойства объекта.
   */
  constructor(props) { Object.assign(this, props); }
}
/**
 * Вид компонента.
 * @param {Object} props - Атрибуты элемента.
 * @param {SampleModel} props.model - Модель компонента.
 * @returns {JSX.Element} Элемент JSX.
 */
function SampleView({ model }) {
  return (
    <WidgetFrame icon="clipboard_list" title={Sample.title}>
      <a href="#toggle" onClick={model.onToggle}>
        {locale.boolean(model.state)}
      </a>
    </WidgetFrame>
  );
}
// Локализация
const locale = new Locale("Sample",
  {
  });
Sample.title = "MVC";
